import React, { type JSX } from 'react';
import { MdClear } from 'react-icons/md';

export interface UploadedFileWithKey<T extends UploadedFile> {
  key: string;
  file: T;
}

export interface UploadedFile {
  filename: string;
  url: string;
}

export interface FileListProps<T extends UploadedFile> extends React.ComponentPropsWithoutRef<'ul'> {
  files: UploadedFileWithKey<T>[];
  setFiles?: (files: UploadedFileWithKey<T>[]) => void;
}

export const FileList = <T extends UploadedFile>({ files, setFiles, ...props }: FileListProps<T>): JSX.Element => {
  const handleRemoveFile = (x: UploadedFileWithKey<T>) => () => {
    setFiles?.(files.filter(y => y !== x));
  };
  return (
    <ul {...props}>
      {files.map(x => (
        <li key={x.key} className="py-1">
          {setFiles && (
            <button type="button" className="align-middle" onClick={handleRemoveFile(x)}>
              <MdClear className="text-content-negative w-5 h-5 cursor-pointer" />
              <span className="sr-only">Remove {x.file.filename}</span>
            </button>
          )}
          {` ${x.file.filename}`}
        </li>
      ))}
    </ul>
  );
};
